import { unitSystem } from '../../state/unitSystemStore'
import { getUnitLabel, type Quantity } from '../../utils/units'
import LabeledInput from './LabeledInput'

type QuantityFieldProps = {
   id: string
   quantity: Exclude<Quantity, 'duration'>
   /** Label template with a `{unit}` placeholder, already translated. */
   label: (unit: string) => string
   value: string
   onValueInput: (value: string) => void
   step?: string
   placeholder?: string
}

/**
 * Renders a labeled decimal input for a physical quantity, with the unit of the
 * active unit system in the label.
 *
 * @param props - Id, quantity, label builder, value, handler, and input hints.
 * @returns The field element.
 */
const QuantityField = (props: QuantityFieldProps) => (
   <LabeledInput
      type="number"
      id={props.id}
      label={props.label(getUnitLabel(props.quantity, unitSystem()))}
      step={props.step ?? '0.1'}
      min="0"
      inputmode="decimal"
      value={props.value}
      onValueInput={props.onValueInput}
      placeholder={props.placeholder}
   />
)

export default QuantityField
